export type ProfileLocationLike = {
  village?: unknown
  gram_panchayat_id?: unknown
  gram_panchayat_name?: unknown
}

function trimString(value: unknown) {
  return String(value ?? "").trim()
}

export function getProfileGramPanchayatId(profile: ProfileLocationLike | null | undefined) {
  const nextId = trimString(profile?.gram_panchayat_id)
  if (nextId) return nextId
  return trimString(profile?.village)
}

export function getProfileGramPanchayatName(profile: ProfileLocationLike | null | undefined) {
  const nextName = trimString(profile?.gram_panchayat_name)
  if (nextName) return nextName
  const legacyVillage = trimString(profile?.village)
  if (/^\d+$/.test(legacyVillage)) return ""
  return legacyVillage
}
